import React from "react"
import LazyImage from "../../../components/LazyImage"

export const Card = ({ image, header, text }) => {
    return (
        <div className="card">
            <LazyImage alt="card" src={image} className="card-image" />
            <div className="card-text">
                <h4 className="t-s3">{header}</h4>
                <p className="t-b4">{text}</p>
            </div>
        </div>
    )
}
